import { render, staticRenderFns } from "./back-forward.vue?vue&type=template&id=4e862ff0&scoped=true"
import script from "./back-forward.vue?vue&type=script&lang=js"
export * from "./back-forward.vue?vue&type=script&lang=js"
import style0 from "./back-forward.vue?vue&type=style&index=0&id=4e862ff0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e862ff0",
  null
  
)

export default component.exports